export type ToastTone = "info" | "success" | "error";

const DEFAULT_MS: Record<ToastTone, number> = {
  info: 4200,
  success: 3200,
  error: 5600,
};

let stack: HTMLElement | null = null;

function ensureStack(): HTMLElement {
  if (stack?.isConnected) {
    return stack;
  }
  stack = document.getElementById("toast-stack");
  if (!stack) {
    stack = document.createElement("div");
    stack.id = "toast-stack";
    stack.className = "toast-stack";
    stack.setAttribute("aria-live", "polite");
    stack.setAttribute("aria-relevant", "additions");
    document.body.append(stack);
  }
  return stack;
}

/** Short unobtrusive message; tap to dismiss. */
export function showToast(message: string, tone: ToastTone = "info", durationMs?: number): void {
  const text = message.trim();
  if (!text) {
    return;
  }
  const host = ensureStack();
  const toast = document.createElement("div");
  toast.className = `toast toast-${tone}`;
  toast.setAttribute("role", tone === "error" ? "alert" : "status");
  toast.textContent = text;
  host.append(toast);
  requestAnimationFrame(() => {
    toast.classList.add("is-in");
  });
  const ms = durationMs ?? DEFAULT_MS[tone];
  let timer = window.setTimeout(dismiss, ms);
  function dismiss(): void {
    window.clearTimeout(timer);
    toast.classList.remove("is-in");
    window.setTimeout(() => toast.remove(), 280);
  }
  toast.addEventListener("click", dismiss);
}
